import { Dispatch, useCallback } from 'react';
import { LinkTrackingData } from '../../../../AnalyticsContext/LinkTracking';
import { TrackingEvent } from '../../../../AnalyticsContext/TrackingEvent';
import { useAnalytics } from '../../../../AnalyticsContext/useAnalytics';
import { useArrowKeyIndex } from '../../../../hooks/keyboard/useArrowKeyIndex';
import { useEnterKeyHandler } from '../../../../hooks/keyboard/useEnterKeyHandler';
import { safeMemo } from '../../../../util/safeMemo';
import { SuggestionData } from '../types';
import { SuggestionListItem } from './SuggestionListItem/SuggestionListItem';

interface Props {
  onChoose: Dispatch<SuggestionData>;
  searchTerm: string;
  suggestions: SuggestionData[];
  trackingData: LinkTrackingData;
}

export const SuggestionList = safeMemo(
  ({ suggestions, onChoose, trackingData, searchTerm }: Props) => {
    const [selectedIndex, setSelectedIndex] = useArrowKeyIndex(suggestions.length);
    const { trackEvent } = useAnalytics();

    const chooseSelection = useCallback(() => {
      const selectedSuggestion = suggestions[selectedIndex];
      if (selectedSuggestion) onChoose(selectedSuggestion);
    }, [onChoose, selectedIndex, suggestions]);

    useEnterKeyHandler(() => {
      trackEvent(TrackingEvent.SEARCH_BAR_ENTER_PRESS, {
        searchData: {
          term: searchTerm,
        },
      });

      chooseSelection();
    });

    return (
      <>
        {suggestions.map((suggestion, i) => (
          <SuggestionListItem
            key={suggestion.id}
            index={i}
            suggestion={suggestion}
            onChoose={onChoose}
            onMouseOver={setSelectedIndex}
            selected={i === selectedIndex}
            trackingData={trackingData}
          />
        ))}
      </>
    );
  },
);
